/**
 * Rollen — één definitie voor alle rol-checks in de frontend (spiegel van backend/utils/rollen.py; een test bewaakt gelijkheid).
 * Voorstel 67/68: meerdere rollen per medewerker (`rollen`, `role` = hoofdrol). Gebruik heeftRol/isManager/isManagement/isDirectie.
 */
export const DIRECTIE = ["manager_plus"];
export const MANAGERS = ["manager_plus", "manager", "manager_operationeel", "manager_bedrijfsvoering", "manager_brandveiligheid"];
export const MANAGEMENT = [...MANAGERS, "teammanager"];
export const ALLE_ROLLEN = ["manager_plus", "manager", "manager_operationeel", "manager_bedrijfsvoering", "manager_brandveiligheid", "teammanager",
  "kcc", "salesteam", "accountmanager", "buitendienst_nl", "buitendienst_be", "projectleider_pb", "applicateur"];
export const ROL_LABELS = {
  manager_plus: "COO (operationeel directeur)", manager: "Manager", manager_operationeel: "Manager operationeel",
  manager_bedrijfsvoering: "Manager bedrijfsvoering", manager_brandveiligheid: "Manager brandveiligheid", teammanager: "Teammanager",
  kcc: "KCC", salesteam: "Salesteam", accountmanager: "Accountmanager", buitendienst_nl: "Buitendienst NL", buitendienst_be: "Buitendienst BE",
  projectleider_pb: "Projectleider BB", applicateur: "Applicateur",
};
const ROL_ALIAS = { directie: "manager_plus", directeur: "manager_plus", coo: "manager_plus", manager_algemeen: "manager", manager_hr: "manager_bedrijfsvoering",
  buitendienst: "buitendienst_nl", monteur: "buitendienst_nl",
  binnendienst: "kcc", binnendienst_nl: "kcc", binnendienst_be: "kcc", medewerker: "kcc", klantenservice: "salesteam" };

export const canon = (rol) => (rol ? ROL_ALIAS[rol] || rol : rol);
export const rolLabel = (rol) => ROL_LABELS[canon(rol)] || rol || "—";
/** Alle rollen van een gebruiker/medewerker, hoofdrol eerst (accepteert ook een losse rol-string). */
export const rollenVan = (u) => {
  if (!u) return [];
  if (typeof u === "string") return [canon(u)];
  const hoofd = canon(u.role || u.rol);
  let lijst = (u.rollen || []).filter(Boolean).map(canon);
  if (hoofd && !lijst.includes(hoofd)) lijst = [];
  return [...new Set([...(hoofd ? [hoofd] : []), ...lijst])];
};
// Voorstel 68: Accountmanager heeft dezelfde rechten als KCC
const RECHTEN_ALS = { accountmanager: "kcc" };
export const heeftRol = (u, ...rollen) => { const doel = rollen.flat().map(canon); return rollenVan(u).some((r) => doel.includes(r) || doel.includes(RECHTEN_ALS[r])); };
export const isDirectie = (u) => heeftRol(u, DIRECTIE);
export const isManager = (u) => heeftRol(u, MANAGERS);
export const isManagement = (u) => heeftRol(u, MANAGEMENT);
